import { createContext, useContext } from 'react'
import type { NotificationFeed } from './notification-feed'

export const CommunicationNotificationContext = createContext<
  NotificationFeed & { acknowledge: () => Promise<void> }
>({ total: 0, entries: [], acknowledge: () => Promise.resolve() })
export const useCommunicationNotifications = () =>
  useContext(CommunicationNotificationContext)
